import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "./languageMap";

export const detectBrowserLanguage = () => {
  const browserLang = navigator.language;
  const langCode = browserLang.split("-")[0];

  return (
    SUPPORTED_LANGUAGES.find(
      (lang) => lang === browserLang || lang.startsWith(langCode),
    ) || DEFAULT_LANGUAGE
  );
};
